import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as app_consts from "../../../utils/app_consts";
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { TENANT_RETRIEVE_PROMOTION_MENU_IDENTIFIER_SETTINGS_API, TENANT_UPDATE_PROMOTION_MENU_IDENTIFIER_SETTINGS_API } from '../../../api/api_data';
import { fail_retrieve_tenant_promotions_menu_identifier_settings, loading_retrieve_tenant_promotions_menu_identifier_settings, reset_retrieve_tenant_promotions_menu_identifier_settings, success_retrieve_tenant_promotions_menu_identifier_settings } from '../../../reducers/auth_tenant/retrieve_tenant_promotions_menu_identifier_settings_Slice';
import { RETRIVE_SETTINGS_DETAILS_ERROR_MSG, RETRIVE_SETTINGS_DETAILS_SUCCESS_MSG, UPDATE_SETTINGS_DETAILS_ERROR_MSG, UPDATE_SETTINGS_DETAILS_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { messageToast } from '../../../utils/Utils';
import { Button, Col, Icon, Row } from '../../Component';
import TextInput from '../../../pages/components/inputs/TextInput';
import { fail_tenant_update_promotions_menu_identifier_settings, loading_tenant_update_promotions_menu_identifier_settings, reset_tenant_update_promotions_menu_identifier_settings, success_tenant_update_promotions_menu_identifier_settings } from '../../../reducers/auth_tenant/tenant_update_promotions_menu_identifier_settings_Slice';
import moment from 'moment';

const initial_state = { promotion_id: "", menu_identifier_id: "" };

const ViewMenuIdentifierPromotionDetailsModal = ({ isOpen, closeModal, tenant_info, user_info, successFunction, data }) => {

 const [page_data, setPageData] = useState([]);
 const [open, setOpen] = useState(isOpen);
 const [loading, setLoading] = useState(true);
 const [error, setError] = useState("");
 const dispatch = useDispatch();
 const [editMode, setEditMode] = useState(false);
 const [form_data, setFormData] = useState(initial_state);
 const [update_loading, setUpdateLoading] = useState(false);
 const [update_error, setUpdateError] = useState("");
 const [sent_data, setSentData] = useState(data);

 useEffect(() => {
  if (isOpen && data)
  {
   // Dispatch
   setEditMode(false);
   retrieve_data(data);
   setSentData(data);
   setUpdateError('');
   setError("");
  }
  setOpen(isOpen);
 }, [isOpen, data]);

 const retrieve_data = (id) => {
  setError('');
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_promotions_menu_identifier_settings, success_retrieve_tenant_promotions_menu_identifier_settings, fail_retrieve_tenant_promotions_menu_identifier_settings, RETRIVE_SETTINGS_DETAILS_ERROR_MSG, RETRIVE_SETTINGS_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_PROMOTION_MENU_IDENTIFIER_SETTINGS_API}/${id}`));
 };

 // Listener
 const retrieve_tenant_promotions_menu_identifier_settings_listener = useSelector((state) => state.retrieve_tenant_promotions_menu_identifier_settings.retrieve_tenant_promotions_menu_identifier_settings);

 useEffect(() => {
  if (retrieve_tenant_promotions_menu_identifier_settings_listener.status !== app_consts.IDLE)
  {
   if (retrieve_tenant_promotions_menu_identifier_settings_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    setLoading(false);
    if (retrieve_tenant_promotions_menu_identifier_settings_listener.status === app_consts.FAIL)
    {
     setError(retrieve_tenant_promotions_menu_identifier_settings_listener.message);
     messageToast(retrieve_tenant_promotions_menu_identifier_settings_listener.message, app_consts.FAIL);
    } else if (retrieve_tenant_promotions_menu_identifier_settings_listener.status === app_consts.SUCCESS)
    {
     setPageData(retrieve_tenant_promotions_menu_identifier_settings_listener.data);
    }
    dispatch(reset_retrieve_tenant_promotions_menu_identifier_settings());
   }
  }
 }, [retrieve_tenant_promotions_menu_identifier_settings_listener]);

 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...form_data, [e.target.name]: e.target.value });
 };

 const handle_edit_identifier_config = () => {
  setUpdateError('');
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_tenant_update_promotions_menu_identifier_settings, success_tenant_update_promotions_menu_identifier_settings, fail_tenant_update_promotions_menu_identifier_settings, UPDATE_SETTINGS_DETAILS_ERROR_MSG, UPDATE_SETTINGS_DETAILS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_UPDATE_PROMOTION_MENU_IDENTIFIER_SETTINGS_API}`, { ...form_data, promotion_id: sent_data }));
 };

 // Listener
 const tenant_update_promotions_menu_identifier_settings_listener = useSelector((state) => state.tenant_update_promotions_menu_identifier_settings.tenant_update_promotions_menu_identifier_settings);

 useEffect(() => {
  if (tenant_update_promotions_menu_identifier_settings_listener.status !== app_consts.IDLE)
  {
   if (tenant_update_promotions_menu_identifier_settings_listener.status === app_consts.LOADING)
   {
    setUpdateLoading(true);
    setUpdateError("");
   } else
   {
    setUpdateLoading(false);
    if (tenant_update_promotions_menu_identifier_settings_listener.status === app_consts.FAIL)
    {
     setUpdateError(tenant_update_promotions_menu_identifier_settings_listener.message);
     messageToast(tenant_update_promotions_menu_identifier_settings_listener.message, app_consts.FAIL);
    } else if (tenant_update_promotions_menu_identifier_settings_listener.status === app_consts.SUCCESS)
    {
     messageToast(UPDATE_SETTINGS_DETAILS_SUCCESS_MSG, app_consts.SUCCESS);
     successFunction();
     retrieve_data(sent_data);
     setEditMode(false);
    }
    dispatch(reset_tenant_update_promotions_menu_identifier_settings());
   }
  }
 }, [tenant_update_promotions_menu_identifier_settings_listener]);


 return (
  <>
   <Modal isOpen={open} toggle={loading ? "" : closeModal} className="modal-dialog-centered" size={"md"}>
    <ModalHeader toggle={loading ? "" : closeModal}>Promotion Menu Identifier Settings</ModalHeader>
    <ModalBody>
     {
      loading ?
       <>
        <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
         <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>Retrieving Promotion Menu Identifier Settings...</div>
         <div className="nk-loader mt-2  w-70 m-auto "></div>
        </div>
       </>
       :
       <>
        {
         error ?
          <>
           <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
            <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>{error}</div>
           </div>
          </>
          :
          <>
           <div className='mt-4'>
           </div>
           {
            editMode ?
             <>
              <Row className="g-4">
               <TextInput
                label="Menu Identifier ID"
                type="text"
                id_val="campaign_id"
                value={form_data?.menu_identifier_id}
                colSize="12"
                required
                name="menu_identifier_id"
                handleChange={handleChange}
               />
              </Row>
              <hr />
              <Row className="g-4 mt-4">
               {update_error && (
                <div className="mb-3 w-100">
                 <Alert color="danger" className="alert-icon">
                  <Icon name="alert-circle" /> {update_error}{" "}
                 </Alert>
                </div>
               )}
               <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                <Button className='mx-2' onClick={() => setEditMode(false)} disabled={update_loading} color="gray">
                 Cancel
                </Button>
                <Button onClick={handle_edit_identifier_config} disabled={
                 (update_loading) ||
                 !(form_data?.menu_identifier_id)
                } color="primary">
                 {update_loading ? <Spinner size="sm" color="light" /> : "Update Menu Identifier Settings"}
                </Button>
               </Col>
              </Row>
             </>
             :
             <>
              {
               page_data?.menu_identifier_settings ?
                <>
                 <div className="m-auto d-flex flex-row justify-content-start align-center my-4" >
                  <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData({ initial_state }); }} color="primary" size="sm">
                   Edit Menu Identifier Settings
                  </Button>
                 </div>
                 <Row className="g-4">
                  <TextInput
                   label="Menu ID"
                   type="text"
                   id_val="menu_id"
                   value={page_data?.menu_identifier_settings?.menu_id || "--"}
                   colSize="12"
                   disabled
                   name="menu_id"
                  />
                  <TextInput
                   label="Last Updated On"
                   type="text"
                   id_val="last_updated_on"
                   value={page_data?.menu_identifier_settings?.last_updated_on ? moment(page_data?.menu_identifier_settings?.last_updated_on).format("YYYY-MM-DD HH:mm:ss") : "--"}
                   colSize="12"
                   disabled
                   name="last_updated_on"
                  />
                 </Row>
                </>
                :
                <>
                 <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold my-4" style={{ fontSize: 18 }}>Menu Identifier Settings Have not Been Set</div>

                  <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData(initial_state); }} color="primary" size="sm">
                   Add Menu Identifier Settings
                  </Button>
                 </div>
                </>
              }
             </>
           }
          </>
        }
       </>
     }
    </ModalBody>
   </Modal>
  </>
 );
};

export default ViewMenuIdentifierPromotionDetailsModal;